import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedule({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_technicians/fetch_container_scheduled_service/${container_scheduled_service_id}`
    );
  },
  fetchTechnicians({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_technicians/fetch_technicians/${container_scheduled_service_id}`
    );
  },
  update({ container_scheduled_service_id, user_ids }) {
    return RequesterV1.patch(
      `service_provider/services/container_op/edit_technicians/update/${container_scheduled_service_id}`,
      { user_ids }
    );
  },
};
